import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'evi-desktop-oven-view',
  templateUrl: './oven-view.component.html',
  styleUrls: ['./oven-view.component.scss'],
  standalone: false,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class OvenViewComponent {
}
